<template>
  <v-form ref="form" style="width: 100%;">
    <v-row>
        <template v-for="(section, i) in sections">
          <template v-if="section.section && sectionVisibility(section)">
            <v-list-item :key="`section-title-${i}`">
              <v-list-item-content class="text-h6">
                {{ section.section }}
              </v-list-item-content>
            </v-list-item>

            <v-divider
              :key="`section-divider-${i}`"
              class="mb-3 px-4 section--divider"
              light
            ></v-divider>
          </template>

          <template v-for="field in section.fields">

            <div
              :key="`linebreak-${field.sequence}`"
              v-if="(field.config || {}).inline !== 'true'"
              class="linebreak"
            ></div>
            <Field
              :ref="`field-${field.alias}`"
              :key="field.sequence"
              :eventBus="eventBus"
              :expressionInterpreter="expressionInterpreter.interpreter(field.alias)"
              :label="field.name"
              :required="field.required"
              :alias="field.alias"
              :type="field.type.name"
              :config="field.config"
              :params="field.params"
              :dependency="field.dependency"
              :disabled="lock"
              :sections="sections"
            ></Field>
          </template>
        </template>
        <br/>
        <v-card-actions
        class="d-flex flex-wrap justify-end col-12 px-3"
        :class="[
          isExtendedSearch ? 'botonera__form_extended_search' : 'botonera__form',
          { 'pr-12': isDesktop }
        ]"
        v-if="(buttons.length || submitVisible) && showButtons"
        >
        <p v-if="warningText != ''"
        :style="{
          marginRight: 'auto',
          marginBottom: '0px',
          color: '#E3B086'}"
        >{{ warningText }}</p>
          <v-btn
            :disabled="lock || btnDisabled"
            v-if="showButtons && !buttons.length"
            :block="!$vuetify.breakpoint.mdAndUp"
            color="primary"
            @click="submit('submit')"
            v-show="submitVisible"
          >{{ $t('views.form.send') }}</v-btn>

          <v-btn
            :disabled="lock || btnDisabled"
            color="primary"
            :block="!$vuetify.breakpoint.mdAndUp"
            v-for="btn in buttons"
            :key="`form-submit-${btn}`"
            @click="submit(btn)"
            v-show="submitVisible"
            class="ma-2"
          >{{ btn }}</v-btn>
          <slot name="newButton" v-if="!!$slots.newButton"></slot>
        </v-card-actions>
    </v-row>
  </v-form>
</template>

<script>
import Field, { FIELD_TYPES, EXTENDED_FIELD_TYPES } from './Field.vue';
import FormExpressionInterpreter from './form-expression-interpreter';

const INPUT_TYPES = Object.values(FIELD_TYPES)
  .concat( // extend valid input types with custom extended field types
    Object.values(EXTENDED_FIELD_TYPES)
      .map((extendedFieldTypeEntry) => extendedFieldTypeEntry[1]),
  );

export default {
  props: {
    id: String,
    data: {
      type: Object,
      required: true,
    },
    buttons: {
      type: Array,
      default: () => [],
    },
    lock: {
      type: Boolean,
      default: () => false,
    },
    submitVisible: {
      type: Boolean,
      default: () => true,
    },
    profileViewForm: {
      type: Boolean,
      default: () => false,
    },
    showButtons: {
      type: Boolean,
      default: () => true,
    },
    warningText: {
      type: String,
      default: () => '',
    },
    isExtendedSearch: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    Field,
  },
  data({ id, data }) {
    return {
      sections: data.properties.reduce((tot, curr) => {
        const currSection = tot.length ? tot[tot.length - 1] : null;
        if (typeof (curr.config || {}).section === 'string') {
          // field section configured
          if (currSection != null && currSection.section === curr.config.section) {
            currSection.fields.push(curr);
          } else {
            tot.push({ section: curr.config.section, fields: [curr] });
          }
        } else if (currSection != null && currSection.section == null) {
          currSection.fields.push(curr);
        } else {
          tot.push({ fields: [curr] });
        }
        return tot;
      }, []),
      eventBus: this.$events.create(`form-${id}`),
      expressionInterpreter: new FormExpressionInterpreter({
        staticContextFields: {
          element: data,
          user: this.$store.getters['session/user'],
        },
        getFieldsCtx: this.getFieldsCtx,
      }),
      btnDisabled: true,
      elementForInsert: [],
    };
  },
  computed: {
    isDesktop() {
      const desktop = window.matchMedia('screen and (min-width: 960px)');
      return desktop.matches;
    },
  },
  methods: {
    sectionVisibility(section) {
      /* TODO: expressionInterpreter */
      if (!section.fields || section.fields.length === 0) {
        return false;
      }
      let visible = true;
      const sectionLength = new Array(section.fields.length);
      console.log('V.SECTION', { section, sectionLength });
      section.fields.forEach((field) => {
        console.log('this.expressionInterpreter', { e: this.expressionInterpreter, a: field.alias });
        if (this.expressionInterpreter[field.alias]) {
          // Para poder comprobar el visibility nos crearemos un interpreter
          const interpreter = this.expressionInterpreter.interpreter(field.alias);
          console.log('interpreter', interpreter);
          // Si existe dependecy, evaluamos visibility, sino se muestra por defecto
          console.log('interpreter.dependency', interpreter.dependency);
          if (interpreter && interpreter.formInterpreter
          && interpreter.formInterpreter[field.alias]
          && interpreter.formInterpreter[field.alias].dependency) {
            console.log('V.dependency', interpreter.formInterpreter[field.alias]);
            console.log('V.visible', Boolean(interpreter.eval('dependency.visibility', false, this.expressionInterpreter[field.alias])));
            // De esta manera podemos comprobar si es true o false,
            // ya que a veces nos devuelve un string
            const isVisible = Boolean(interpreter.eval('dependency.visibility', false, this.expressionInterpreter[field.alias]));
            console.log('visible', { isVisible });
            sectionLength.push(isVisible);
          } else {
            // Si no tiene dependencia, se muestra por defecto
            console.log('V.no dependency');
            visible = true;
            sectionLength.push(visible);
          }
        }
      });
      console.log('sectionLength', sectionLength);
      // Comprobamos si al menos un campo es visible para mostrar la sección
      visible = sectionLength.some((fieldVisible) => fieldVisible === true);
      return visible;
    },
    getFormData() {
      const { fieldsContext } = this.expressionInterpreter;
      const items = Object.entries(fieldsContext);
      console.log('items', items);
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined' && entry[1].value !== null && entry[1].value !== '')
          .map((entry) => [entry[0], entry[1].value]),
      );
    },
    getFormDataWithDeleted() {
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined')
          .map((entry) => [entry[0], entry[1].value]),
      );
    },
    getFieldsCtx() {
      const $form = this.$children[0];
      const inputChildren = $form.$children
        .filter((child) => INPUT_TYPES.includes(child.component));

      return inputChildren.reduce((tot, curr) => {
        // const childData = curr.getContextData();
        // eslint-disable-next-line no-param-reassign
        tot[curr.alias] = curr.fieldValue;
        return tot;
      }, {});
    },
    validate(formData) {
      console.log('****validate', formData);
      const { feedback } = formData;
      // Valoracion sera true cuando valor > 2 o cuando valor <= 2 y comentario no este vacio
      let valoracion = !feedback;
      if (feedback && feedback.starsScore <= 2
      && feedback.comment != null
      && feedback.comment !== undefined
      && feedback.comment.trim() !== '') {
        valoracion = true;
      } else if (feedback && feedback.starsScore > 2) {
        valoracion = true;
      }
      console.log('****validate', { feedback, valoracion });
      console.log('****validate return ', feedback ? this.$refs.form.validate() && valoracion : this.$refs.form.validate());
      return feedback ? this.$refs.form.validate() && valoracion : this.$refs.form.validate();
    },
    validationLdap(ldap) {
      let valid = true;
      if (ldap.length > 0
        && ldap[0].rama === 'sspa'
        && ldap[0].tipo === 'externo'
      ) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.sspaext'),
          type: 'warning',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
          router: '/element/r/AE8358F7C84601FB9A1B000C29B08512',
          routerTitle: 'Alta VPN para usuarios externos',
        });
        valid = false;
      } else if (ldap.length > 0
        && ldap[0].rama === 'sspa'
        && ldap[0].tipo === 'genérico') {
        valid = false;
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.sspagen'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } else if (ldap.length > 0
      && ldap[0].rama !== 'sas'
      && ldap[0].rama !== 'sspa'
      && ldap[0].rama !== 'FIBAO') {
        valid = false;
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.notsassspafibao'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } else if (ldap.length > 0
      && ldap[0].rama === 'FIBAO') {
        valid = false;
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.sspaext'),
          type: 'warning',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
          router: '/element/r/AE8358F7C84601FB9A1B000C29B08512',
          routerTitle: 'Alta VPN para usuarios externos',
        });
      } else if (ldap.length === 0) {
        valid = false;
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.empty'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
          router: '/profile/edit',
          routerTitle: 'información de perfil',
        });
      }
      return valid;
    },
    async submit(submitBtn) {
      const { form } = this.$refs;
      const formData = this.getFormData();
      console.log('****formData', formData);
      // if (formData.vpnUser && formData.vpnUser.length > 0) {
      //   console.log('vpnUser', formData.vpnUser);
      //   this.$store.dispatch('messages/createNotificationMessage', {
      //     title: this.$t('validation.vpnUser'),
      //     type: 'error',
      //     dismissible: true,
      //     timeout: this.$getConst('notifications.timeoutPlus'),
      //   });
      //   this.btnDisabled = true;
      //   return false;
      // }
      if (formData.ldapSubmit && !this.validationLdap(formData.ldapSubmit)) {
        return false;
      }
      console.log('****form.validate()', form.validate());
      console.log('****validate()', this.validate(formData));
      // if (!form.validate()) {
      if (!this.validate(formData)) {
        this.$nextTick(() => {
          const domRect = document.querySelector('.v-input.error--text').getBoundingClientRect();
          window.scrollTo(
            domRect.left + document.documentElement.scrollLeft,
            // 74 = 64 toolbarheight + 10 margi
            domRect.top + document.documentElement.scrollTop - 74,
          );
        });
        return false;
      }

      // const formData = this.getFormData();

      const suscriptorsListLocalStorage = localStorage.getItem('suscriptorsList');
      if (suscriptorsListLocalStorage && suscriptorsListLocalStorage.length > 0) {
        const suscriptorsList = JSON.parse(suscriptorsListLocalStorage);
        if (suscriptorsList && suscriptorsList.length > 0) {
          let suscriptorsListAll = '';
          let suscriptorsListName = '';
          suscriptorsList.forEach((item) => {
            suscriptorsListAll += `${ item.id };`;
            suscriptorsListName += `${ item.name },`;
          });
          const suscriptorsAll = suscriptorsListAll.slice(0, -1);
          const suscriptorsData = {
            names: suscriptorsListName.slice(0, -1),
            ids: suscriptorsAll.replace(';', ','),
            codigoFlujo: 400001,
          };
          formData.suscriptorAll = suscriptorsAll;
          formData.suscriptorsData = suscriptorsData;
        }
        localStorage.removeItem('suscriptorsList');
      }

      // adding hidden fields to form data
      this.data.properties
        .filter((p) => p.type.name === 'hidden')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .filter((p) => p.fieldValue.value != null)
        .forEach((p) => {
          formData[p.alias] = p.fieldValue.value;
        });
      // adding not visible fields with submit to true to form data
      this.data.properties
        .filter((p) => String((p.config || {}).submit) === 'true' && String((p.dependency || {}).visibility) === 'false')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .filter((p) => p.fieldData.initialValue != null)
        .forEach((p) => {
          formData[p.alias] = p.fieldData.initialValue;
        });

      this.data.properties.forEach((item) => {
        const t = formData[item.alias];
        if (item?.special_values && Object.keys(item?.special_values).length > 1) {
          const { special_values: specialValue } = item;
          if (specialValue && specialValue?.integrationid && specialValue?.integrationname) {
            if (
              t
              && t[item.special_values.integrationid] === t[item.special_values.integrationname]
            ) {
              t.id = this.$refs[`field-${item.alias}`][0].fieldValue.item.id;
              t.value = this.$refs[`field-${item.alias}`][0].fieldValue.value.value;
            }
          }
        }
      });

      const attachments = this.data.properties
        .filter((p) => p.type.name === 'file')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .flatMap((fileField) => fileField.$children)
        .filter((fileComponent) => fileComponent.$vnode.componentOptions.tag === 'FileField')
        .flatMap((fileComponent) => fileComponent.files);

      console.log('****submit', {
        submitBtn, formData, attachments,
      });
      this.$emit('click:submit', {
        action: submitBtn,
        data: formData,
        attachments,
      });

      return true;
    },
    shouldUpdateUserLocation() {
      const refs = this.$refs['field-workplace'];
      if ((refs || []).length === 0) {
        return false;
      }
      const [workplaceField] = refs;
      return workplaceField.$children.length > 0
        // check into wordplace component if switch is enabled
        && workplaceField.$children[0].overrideUserWorkplace === true;
    },
    getFormDataAll() {
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined' && entry[1].value !== null && entry[1].value !== ''),
      );
    },
  },
  beforeDestroy() {
    this.$events.destroy(`form-${this.id}`);
  },
  created() {
    const elementForInsertLocalStorage = localStorage.getItem('elementForInsert');
    if (elementForInsertLocalStorage && elementForInsertLocalStorage.length > 0) {
      this.elementForInsert = JSON.parse(elementForInsertLocalStorage);
    } else {
      this.elementForInsert = [];
    }

    if (this.$props.profileViewForm !== true) {
      this.eventBus.on('form:disableSubmit', (disableSubmit) => {
        this.$props.submitVisible = !disableSubmit;
      });

      this.eventBus.on('form:change', (data) => {
        const dataFormAll = this.getFormDataAll();
        const dataChange = {
          dataForm: dataFormAll,
          alias: data.alias,
        };
        setTimeout(() => {
          this.$root.$emit('UpdateFiledForm', dataChange);
          this.btnDisabled = false;
        }, 1000);
        // this.$root.$emit('UpdateFiledForm', dataChange);
      });
    }
    this.$root.$on('formDisabledBtn', (data) => {
      this.btnDisabled = data;
    });
  },
};
</script>

<style lang="scss" scoped>
  .linebreak {
    height: 0;
  }
  .section--divider, .linebreak {
    flex-basis: 100%;
  }
  a {
    text-decoration: none;
  }

  @media (min-width: 960px) {
    .botonera__form {
      padding-right: 130px !important;
    }
    .botonera__form_extended_search {
      padding-right: 7px !important;
    }
  }
</style>
